import { Component } from '@angular/core';

@Component({
    selector: 'ft-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss',
    imports: [],
})
export class PageNotFoundComponent {}
